import src from "IMAGE";
export default { src, width: 664, height: 200, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARElEQVR42g3IsQmAMBRF0RvUUj5aiIXahKCiiJAtMk3IBtk8rzjNwUb8f1PeQB56TuCSIF6M2fjiQ91WknMsykN2maRrtW8Ejl1qU5YAAAAASUVORK5CYII="};
